module.exports = __webpack_public_path__ + "static/media/logo-linkedin.10ff94cd.jpg";